<script>
import { mapActions } from 'vuex';
// import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';
// import 'vue2-datepicker/locale/es';
import Catalogue from '@/services/catalogue';
import request from '@/services/request'
import ModalPaymentAddOnComponent from '@/components/bill_external/ModalPaymentAddOnComponent.vue';

export default {
    components: {
        // DatePicker
        ModalPaymentAddOnComponent
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            load: false,
            send: false,
            debt: {},
            bills: [],
        };
    },
    methods: {
        setPaymentAddOn(number = false, edit = true) {
            this.prop_edit_child = edit;
            Event.$emit('event-show-addPaymentAddOn', number);
        },
        async deleteBill(id) {
            let tit = 'Canelar factura';
            let txt = 'Seguro que quiere canelar la factura';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.send = true;
                    let _endpoint = '/external_bill/' + id;
                    try {
                        let response = await request.destroy(_endpoint).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                        this.load = false;
                        Event.$emit('event-load-contract_dues');
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                        this.load = false;
                    }
                }
            });
        },
        async list() {
            this.load = true;
            let service = request;
            let _endpoint = '/external_bill?contract_dues_id=' + this.debt.id;
            try {
                let { data } = await service.get(_endpoint)
                if (data) {
                    console.log(data);
                    this.bills = data;
                    this.load = false;
                }
            } catch (error) {
                console.log(error);
                this.load = false;
            }
        },
        closedModal() {
            this.bills = [];
            this.debt = {};
            this.send = false;
            this.$modal.hide('bill-external-dev');
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    computed: {

    },
    created() {
        Event.$on("event-show-bill-external-dev", async (deb) => {
            this.$modal.show('bill-external-dev');
            this.debt = deb;
            this.list();
        });

        Event.$on("event-show-bill-external-debv-list", async () => {
            this.list();

        });

    },
}
</script>
<template>
    <modal name="bill-external-dev" :width="'80%'" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-outline-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i>
        </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Facturas en grupo</h5>
        </div>

        <!-- Body -->
        <div class="modal-body">

            <div class="row" v-if="load">
                <div class="col-md-12">
                    <div class="text-center">
                        <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                        <h5>Cargando</h5>
                    </div>
                </div>
            </div>
            <div class="row" v-else-if="bills.length == 0">
                <div class="col-md-12">
                    <div class="text-center">
                        <h5>Sin facturas</h5>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-12" v-for="(bill, index) in bills" :key="index">                    
                    <div class="card card-outline card-primary p-0">
                        <div class="card-header">
                            <h3 class="card-title">Facturas</h3>

                            <div class="card-tools">

                            </div>
                            <!-- /.card-tools -->
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>Factura a:</label>
                                    <span v-if="bill.billing_data">
                                        {{ bill.billing_data.business_name }}
                                    </span>
                                    <span v-else>
                                        {{ bill.company_name }}
                                    </span>
                                </div>
                                <div class="col-md-6">
                                    <label>UUID:</label>
                                    {{ bill.uuid }}
                                </div>
                                <div class="col-md-3">
                                    <label>Serie:</label>
                                    {{ bill.series }}
                                </div>
                                <div class="col-md-3">
                                    <label>CFDI Version:</label>
                                    {{ bill.cfdi_version }}
                                </div>
                                <div class="col-md-3">
                                    <label>Moneda:</label>
                                    {{ bill.currency }}
                                </div>

                                <div class="col-md-3">
                                    <label>Datos de facturación:</label>
                                    {{ bill.currency }}
                                </div>

                                <div class="col-md-3">
                                    <label>Método de pago:</label>
                                    {{ bill.payment_method }}
                                </div>
                                <div class="col-md-12">
                                    <hr>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Concepto</th>
                                                <th>Monto</th>
                                                <th>Descuento</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="bill.items == 0">
                                            <tr>
                                                <td colspan="4" class="text-center">
                                                    Sin itmes
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr v-for="(item, index) in bill.items" :key="index">
                                                <td>{{ item.id }}</td>
                                                <td>
                                                    {{ item.description }}
                                                    <hr>
                                                    <strong>IVA:</strong>
                                                    <span v-if="item.iva">
                                                        Si
                                                    </span>
                                                    <span v-else>
                                                        No
                                                    </span>
                                                    <br>
                                                    <strong>IEPS:</strong>
                                                    <span v-if="item.ieps">
                                                        Si
                                                    </span>
                                                    <span v-else>
                                                        No
                                                    </span>
                                                    <br>
                                                    <strong>ISR Ret.:</strong>
                                                    <span v-if="item.isr_ret">
                                                        Si
                                                    </span>
                                                    <span v-else>
                                                        No
                                                    </span>
                                                    <br>
                                                    <strong>IVA Ret.:</strong>
                                                    <span v-if="item.iva_ret">
                                                        Si
                                                    </span>
                                                    <span v-else>
                                                        No
                                                    </span>

                                                </td>
                                                <td>{{ item.final_amount | toCurrency }}</td>
                                                <td> {{ item.discount | toCurrency }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-sm btn-outline-danger"
                                        @click="deleteBill(bill.id)">
                                        <i class="fa-solid fa-file-excel"></i>
                                        Cancelar
                                    </button>
                                </div>
                                <div class="col-6 text-right">

                                    <button @click="setPaymentAddOn(bill)" class="btn btn-sm m-1 btn-outline-primary">
                                        <i class="fa-solid fa-money-bill-transfer"></i>
                                        Complemento de pago
                                    </button>

                                    <a target="_blank" class="btn m-1 btn-outline-success btn-sm"
                                        :href="`${globalUrlFiles}/file/bill_external/${bill.id}/pdf`">
                                        <i class="fas fa-file-pdf "> </i> Archivo PDF
                                    </a>
                                    <a target="_blank" class="btn m-1 btn-outline-secondary btn-sm"
                                        :href="`${globalUrlFiles}/file/bill_external/${bill.id}/xml`">
                                        <i class="fas fa-file "> </i> Archivo XML
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <hr>
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>
            </div>
        </div>
        <ModalPaymentAddOnComponent />

    </modal>
</template>